/* Make It Lab - mobile slider hints. On phones, every horizontal slider on the homepage gets
   prev/next arrows + dots (card sliders) or an edge fade (chip rows), so people know there is more to swipe.
   Targets: .mil-sc-track, .mil-prods, .mil-scroll, .mil-trust (arrows + dots) and .mil-sc-tabs, .mil-sc-subs (fade). */
(function () {
  if (window.__milHints) return;
  window.__milHints = true;
  var MQ = window.matchMedia('(max-width: 760px)');
  var CARDS = '.mil-sc-track,.mil-prods,.mil-scroll,.mil-trust';
  var CHIPS = '.mil-sc-tabs,.mil-sc-subs';

  var css = '.mil-hint{display:none;align-items:center;justify-content:center;gap:10px;margin:12px 0 4px}' +
    '@media (max-width:760px){.mil-hint.on{display:flex}.mil-fade-r{-webkit-mask-image:linear-gradient(to right,#000 82%,transparent);mask-image:linear-gradient(to right,#000 82%,transparent)}' +
    '.mil-fade-l{-webkit-mask-image:linear-gradient(to left,#000 82%,transparent);mask-image:linear-gradient(to left,#000 82%,transparent)}' +
    '.mil-fade-l.mil-fade-r{-webkit-mask-image:linear-gradient(to right,transparent,#000 12%,#000 82%,transparent);mask-image:linear-gradient(to right,transparent,#000 12%,#000 82%,transparent)}}' +
    '.mil-hint__b{width:30px;height:30px;border-radius:50%;border:1.5px solid #0a1a1f;background:#fff;color:#0a1a1f;display:flex;align-items:center;justify-content:center;padding:0;cursor:pointer;transition:opacity .15s,background .15s,color .15s}' +
    '.mil-hint__b:disabled{opacity:.3;cursor:default}.mil-hint__b:not(:disabled):active{background:#0a1a1f;color:#fff}' +
    '.mil-hint__d{display:flex;align-items:center;gap:7px}.mil-hint__dot{width:8px;height:8px;border-radius:50%;border:0;padding:0;background:#c9d6d9;cursor:pointer;transition:background .15s,transform .15s}' +
    '.mil-hint__dot.on{background:#00768c;transform:scale(1.25)}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var CH_L = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
  var CH_R = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';

  function maxScroll(el) { return Math.max(0, el.scrollWidth - el.clientWidth); }

  function setupCards(el) {
    if (el.__mh) return; el.__mh = true;
    var bar = document.createElement('div'); bar.className = 'mil-hint';
    bar.innerHTML = '<button type="button" class="mil-hint__b" aria-label="Previous">' + CH_L + '</button><div class="mil-hint__d"></div><button type="button" class="mil-hint__b" aria-label="Next">' + CH_R + '</button>';
    el.parentNode.insertBefore(bar, el.nextSibling);
    var prev = bar.children[0], dots = bar.children[1], next = bar.children[2], n = 0;
    function build() {
      var m = maxScroll(el), cnt = (m > 6 && el.clientWidth > 0) ? Math.min(8, Math.ceil(el.scrollWidth / el.clientWidth)) : 0;
      if (cnt !== n) {
        n = cnt; dots.innerHTML = '';
        for (var i = 0; i < n; i++) { (function (i) { var d = document.createElement('button'); d.type = 'button'; d.className = 'mil-hint__dot'; d.setAttribute('aria-label', 'Go to slide ' + (i + 1)); d.addEventListener('click', function () { el.scrollTo({ left: n > 1 ? i * maxScroll(el) / (n - 1) : 0, behavior: 'smooth' }); }); dots.appendChild(d); })(i); }
      }
      bar.classList.toggle('on', n > 1 && MQ.matches);
      update();
    }
    function update() {
      var m = maxScroll(el), sl = el.scrollLeft;
      var idx = (n > 1 && m > 0) ? Math.round(sl / m * (n - 1)) : 0;
      for (var i = 0; i < dots.children.length; i++) dots.children[i].classList.toggle('on', i === idx);
      prev.disabled = sl < 4; next.disabled = sl > m - 4;
    }
    prev.addEventListener('click', function () { el.scrollBy({ left: -el.clientWidth * 0.8, behavior: 'smooth' }); });
    next.addEventListener('click', function () { el.scrollBy({ left: el.clientWidth * 0.8, behavior: 'smooth' }); });
    el.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(build).observe(el);
    window.addEventListener('resize', build);
    build(); setTimeout(build, 600); setTimeout(build, 2000);
  }

  function setupChips(el) {
    if (el.__mh) return; el.__mh = true;
    function update() {
      var m = maxScroll(el), sl = el.scrollLeft;
      el.classList.toggle('mil-fade-r', m > 6 && sl < m - 4);
      el.classList.toggle('mil-fade-l', m > 6 && sl > 4);
    }
    el.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(update).observe(el);
    window.addEventListener('resize', update);
    update(); setTimeout(update, 600); setTimeout(update, 2000);
  }

  function init() {
    document.querySelectorAll(CARDS).forEach(setupCards);
    document.querySelectorAll(CHIPS).forEach(setupChips);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();